<template>
	<section class="flex-module flexible-calltoactionlist">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-lg-6 col-lg-offset-3">
					<div class="content-wrapper">
						<h3 class="title">
							{{ item.title }}
						</h3>
						<ul class="arrow-list">
							<li v-for="entry in item.list_items"
								:key="entry.text">
								<BaseRichText :data="entry.text" />
							</li>
						</ul>

						<div class="booking-button-wrapper">
							<baseBookButton classes="button--secondary colored cta-form-reveal"
											:cursor="{ 'custom': true }">
								Get in touch
							</baseBookButton>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true
	}
})

const { $bus } = useNuxtApp()
const item = computed(() => props.data?.item)

function scrollToCalendar() {
	// TODO: Make this check if calendar exists on page, otherwise link to /book
	$bus.$emit('scroll-to-el', { el: '#calendar-wrapper', config: { offset: metaStore.headerHeight * -1 } })
}

</script>

<style lang="scss" scoped>
.title {
	@include textH5;
}

.arrow-list {
	@include arrow-list;

	li {
		@include textBody;

		&:not(:last-of-type) {
			margin-bottom: rem-calc(20);

			@include for-devices-above(md) {
				margin-bottom: rem-calc(25);
			}
		}
	}
}

.booking-button-wrapper {
	text-align: center;
	margin-top: rem-calc(50);

	@include for-devices-above(md) {
		margin-top: rem-calc(100);
	}
}
</style>